import { render, staticRenderFns } from "./TabChecklist.vue?vue&type=template&id=1c1dfcbb&scoped=true"
import script from "./TabChecklist.vue?vue&type=script&lang=js"
export * from "./TabChecklist.vue?vue&type=script&lang=js"
import style0 from "./TabChecklist.vue?vue&type=style&index=0&id=1c1dfcbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1dfcbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VCardText,VContainer,VRadio,VRadioGroup})
